import React, { createContext, useContext, useState } from "react";
import {Loader} from "components/loader/Loader";

const LoaderContext = createContext(undefined);

export const LoaderProvider = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [message, setMessage] = useState("Loading...");

  const showLoader = () => {
    setIsVisible(true);
  };

  const hideLoader = () => {
    setIsVisible(false);
  };

  return (
    <LoaderContext.Provider value={{ showLoader, hideLoader }}>
      {children}
      {isVisible && <Loader message={message} />}
    </LoaderContext.Provider>
  );
};

export const useLoader = ()=> {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error("useLoader must be used within a LoaderProvider");
  }
  return context;
};